"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DescriptionSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Renders Skeleton for `Description`.
 */ const DescriptionSkeleton = (param)=>{
    let { animation = 'pulse', className } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const isMobile = (0, _presentationHooks.useIsMobile)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_constants.DESCRIPTION_SKELETON),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
            variant: "rectangular",
            width: "100%",
            height: isMobile ? '132px' : '88px',
            animation: animation
        })
    });
};
exports.DescriptionSkeleton = DescriptionSkeleton;
